export { default as Stamps } from './Stamps';
